import { render, staticRenderFns } from "./changePasswordRedirect.vue?vue&type=template&id=f41b34ac&"
import script from "./changePasswordRedirect.vue?vue&type=script&lang=js&"
export * from "./changePasswordRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports